
import { defineComponent, onBeforeUnmount, onMounted, PropType, ref } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
    emits: ['close', 'view-details', 'update:modelValue'],
    setup(props, { emit }) {
        const { t } = useI18n()
        const promoActivepage = ref(1)

        let timeOut: number | boolean | any = false

        const INTERVAL = 5000

        onMounted(() => {
            scroll()
        })

        onBeforeUnmount(() => {
            stopScroll()
        })
        const scroll = () => {
            timeOut = setTimeout(() => {
                nextPage()
                scroll()
            }, INTERVAL)
        }
        const stopScroll = () => {
            if (typeof timeOut === 'number') {
                clearTimeout(timeOut)
                timeOut = false
            }
        }

        const nextPage = () => {
            if (promoActivepage.value == 1) promoActivepage.value = 2
            else if (promoActivepage.value === 2) promoActivepage.value = 1
        }

        return {
            nextPage,
            promoActivepage,
            t
        }
    }
})
